module.exports = __webpack_public_path__ + "static/media/icn_other_insurance_fisdom.5d6c0388.svg";